import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { userResponsibilityService } from "../../../shared/api/userResponsibilityService";
import { PermissionName } from "../../../shared/types/permission";
import { UserResponsibilityResource } from "../../../shared/types/userResponsibility";

interface Props {
	userResponsibility: UserResponsibilityResource;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const EvenResponsibilityListContextMenu: FC<Props> = ({ userResponsibility, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => userResponsibilityService.showUsage(userResponsibility.id).then((r) => r.data.data),
		[userResponsibility.id],
	);

	const canUpdate = useHasPermission<PermissionName>(["userResponsibility.update"]);
	const canDelete = useHasPermission<PermissionName>(["userResponsibility.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && userResponsibility.type !== "participant" && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("User responsibility")}
						confirmationBody={t("Are you sure you want to delete this user responsibility?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
